import { Instagram, Lock, Mail } from "lucide-react";
import { Link } from "react-router-dom";
import { BOOKING_EMAIL, BOOKING_MAILTO, LINKS } from "@/data";

export default function Footer() {
  return (
    <footer
      data-testid="page-footer"
      className="relative overflow-hidden border-t border-red-950/50 bg-[#050505]"
    >
      <div className="pointer-events-none absolute inset-0 bg-[radial-gradient(ellipse_at_50%_120%,rgba(200,16,46,0.18),transparent_60%)]" />
      <div className="relative mx-auto max-w-7xl px-5 pb-10 pt-20 sm:px-8">
        <button
          data-testid="footer-brand-title"
          onClick={() => window.__lenis?.scrollTo(0)}
          className="font-display text-outline block w-full text-left text-[13.5vw] leading-none tracking-tight transition-all duration-500 hover:text-[#C8102E] hover:[-webkit-text-stroke:0px] lg:text-[11rem]"
        >
          LINEA CREMISI
        </button>

        <div className="mt-14 flex flex-col items-start justify-between gap-8 border-t border-neutral-900 pt-8 sm:flex-row sm:items-center">
          <div className="flex flex-col gap-2">
            <p className="font-mono-tac text-[11px] uppercase tracking-[0.25em] text-neutral-500">
              © 2026 Linea Cremisi — Suoniamo quello che non si può ignorare
            </p>
            <a
              data-testid="footer-booking-link"
              href={BOOKING_MAILTO}
              className="inline-flex items-center gap-2 font-mono-tac text-[11px] uppercase tracking-[0.25em] text-neutral-400 transition-colors duration-200 hover:text-red-500"
            >
              <Mail className="h-3.5 w-3.5 text-red-700" />
              Booking: {BOOKING_EMAIL}
            </a>
            <Link
              data-testid="footer-admin-link"
              to="/admin"
              className="mt-1 inline-flex items-center gap-1.5 font-mono-tac text-[10px] uppercase tracking-[0.25em] text-neutral-700 transition-colors duration-200 hover:text-red-500"
            >
              <Lock className="h-3 w-3" />
              Area band
            </Link>
          </div>
          <div className="flex items-center gap-4">
            <a
              data-testid="footer-instagram-link"
              href={LINKS.instagram}
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Instagram"
              className="flex h-11 w-11 items-center justify-center border border-neutral-800 text-neutral-400 transition-all duration-200 hover:border-red-600 hover:text-red-500"
            >
              <Instagram className="h-4 w-4" />
            </a>
            <a
              data-testid="footer-spotify-link"
              href={LINKS.spotify}
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Spotify"
              className="flex h-11 w-11 items-center justify-center border border-neutral-800 text-neutral-400 transition-all duration-200 hover:border-red-600 hover:text-red-500"
            >
              <svg viewBox="0 0 24 24" fill="currentColor" className="h-4 w-4">
                <path d="M12 0C5.4 0 0 5.4 0 12s5.4 12 12 12 12-5.4 12-12S18.66 0 12 0zm5.5 17.3c-.2.36-.67.48-1.03.24-2.82-1.72-6.37-2.11-10.55-1.16-.4.1-.8-.16-.9-.56-.1-.4.16-.8.56-.9 4.56-1.04 8.44-.6 11.6 1.33.35.2.46.67.32 1.05zm1.47-3.27c-.26.42-.81.55-1.24.3-3.23-1.99-8.16-2.56-11.98-1.4-.5.15-1.03-.13-1.18-.63-.15-.5.13-1.03.63-1.18 4.37-1.33 9.8-.68 13.53 1.61.42.26.55.81.24 1.3zm.13-3.4C15.24 8.4 8.82 8.16 5.1 9.27c-.6.18-1.23-.16-1.41-.76-.18-.6.16-1.23.76-1.41 4.26-1.29 11.33-1.04 15.8 1.6.54.32.72 1.02.4 1.56-.32.54-1.02.72-1.55.37z" />
              </svg>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
